module.exports = __webpack_public_path__ + "img/fra.1e69cdd4.svg";